import { Link } from "react-router-dom";
import { ArrowUpRight, Flame } from "lucide-react";
import { Reveal, SectionLabel } from "@/lib/Reveal";
import { SERVICES } from "@/lib/data";

export const Services = ({ onBook }) => {
  return (
    <section id="services" data-testid="services-section" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal><SectionLabel>01 / What we fix</SectionLabel></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white mt-4">
                Fixed prices.<br />Zero surprises.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-neutral-400 text-sm leading-relaxed">
              Boilers, gas fires, cookers, hobs, power flushing and plumbing — the price
              you see is the price you pay. Every job carried out by a Gas Safe registered
              engineer with 15+ years on the tools.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.1} className="h-full">
              <article
                data-testid={`service-card-${s.id}`}
                className="group relative h-full bg-surface border border-neutral-800 hover:border-torch rounded-sm p-7 flex flex-col transition-all duration-300 hover:shadow-[inset_0_0_40px_rgba(255,85,0,0.06)] hover:-translate-y-1"
              >
                <span className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-torch opacity-0 group-hover:opacity-100 transition-opacity" />
                <span className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-torch opacity-0 group-hover:opacity-100 transition-opacity" />

                <div className="flex items-center justify-between mb-8">
                  <span className="font-mono text-[10px] tracking-[0.25em] text-torch uppercase">{s.tag}</span>
                  <Flame className="w-4 h-4 text-neutral-700 group-hover:text-torch transition-colors" />
                </div>

                <h3 className="font-display font-bold text-xl text-white leading-snug">{s.name}</h3>
                <p className="mt-3 text-sm text-neutral-400 leading-relaxed flex-1">{s.desc}</p>

                <div className="mt-8 pt-6 border-t border-neutral-800">
                  <div className="flex items-baseline justify-between">
                    <span className="font-mono font-bold text-3xl text-white group-hover:text-torch transition-colors">{s.priceLabel}</span>
                    <span className="font-mono text-[10px] tracking-[0.2em] text-neutral-500 uppercase">{s.duration}</span>
                  </div>
                  <button
                    onClick={() => onBook(s.id)}
                    data-testid={`service-book-${s.id}`}
                    className="mt-5 w-full flex items-center justify-center gap-2 border border-neutral-700 group-hover:border-torch group-hover:bg-torch text-neutral-300 group-hover:text-white font-display font-bold text-sm uppercase tracking-wide py-3 rounded-sm transition-all"
                  >
                    Book this
                    <ArrowUpRight className="w-4 h-4" />
                  </button>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-6 border border-neutral-800 bg-surface rounded-sm px-6 py-6 flex flex-col md:flex-row md:items-center justify-between gap-5" data-testid="also-services-strip">
            <div className="flex flex-col sm:flex-row sm:items-center gap-x-8 gap-y-2">
              <span className="font-mono text-[10px] tracking-[0.25em] text-torch uppercase shrink-0">Also on the van</span>
              <Link to="/heat-pumps" data-testid="also-services-heatpumps-link" className="font-display font-bold text-white text-sm hover:text-torch transition-colors">Air source heat pumps — fitted & serviced →</Link>
              <span className="font-display font-bold text-white text-sm">Plumbing repairs — taps, toilets not flushing, leaks & bursts</span>
              <span className="font-display font-bold text-white text-sm">New radiators supplied & fitted</span>
            </div>
            <a
              href="#plumbing"
              data-testid="also-services-quote-link"
              className="shrink-0 font-mono text-xs uppercase tracking-[0.15em] text-torch border border-torch/40 hover:bg-torch/10 px-4 py-2.5 rounded-sm transition-colors text-center"
            >
              See plumbing services
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
